import { ReportsService } from 'infra/services/reports-service'
import { makeAxiosHttpClient } from '../http/axios-http-client-factory'

export const makeReportsService = () => new ReportsService(makeAxiosHttpClient())
